export default {
  CHILD_DEVELOPMENT: "11",
  EDU_AND_CAREERS: "406",
  E_LEARNING: "12",
  PARENT_CHILD: "8",
  PARENT_SCH: "7",
  READING: "407",
  SELF_LEARNING: "408",
  SPECIAL: "3",
};
